import { render } from "./PolicySearchResultsTable.vue?vue&type=template&id=09ae6905"
import script from "./PolicySearchResultsTable.vue?vue&type=script&lang=js"
export * from "./PolicySearchResultsTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__